<template>
  <div class="px-2 align-items-center justify-content-between text-size-14">
    <div class="d-flex text-size-12" :class="isMobileView ? 'justify-content-center': 'mr-2'">{{ label }} :</div>
    <v-select
      ref="start"
      :options="startTimeOptions"
      :appendToBody="true"
      :clearable="true"
      :searchable="false"
      placeholder="Start"
      :reduce="(title) => title.code"
      :value="startTime"
      @input="setStartTime"
      @open="onFocus"
      @close="onBlurr"
      label="title"
    ></v-select>
  </div>
</template>
<script>
import vSelect from 'vue-select';
// import 'vue2-timepicker/dist/VueTimepicker.css';
import { deviceMixin } from '@/components/mixins/DeviceMixins';

function isValidTime(str) {
  // regular expression to match time in the format of hh:mm
  var timeFormat = /^([01]\d|2[0-3]):([0-5]\d)$/;

  // check if the string matches the time format
  if (timeFormat.test(str)) {
    return true;
  } else {
    return false;
  }
}

export default {
  name: 'RendererChoices',
  props: ['label', 'value'],
  mixins: [deviceMixin],

  data() {
    return {
      myValue: this.value,
      startTime: null,
    };
  },

  components: {
    vSelect,
  },

  computed: {
    startTimeOptions() {
      let list = [];

      if (!this.startTime) {
        let item = {};
        item.code = null;
        item.title = 'Start';
        list.push(item);
      }
      let start = 0;
      let end = 24 * 60;

      for (var i = start; i < end; i += 15) {
        let item = {};
        item.code = i;
        item.title = this.convertMinsToHrsMins(i);

        list.push(item);
      }

      return list;
    },
  },

  methods: {
    setStartTime(value) {
      let tap = this.$refs.start.typeAheadPointer;
      const time = this.Minutes2TimeStr(value);
      console.info('setStartTime value:', time);
      this.startTime = time;
      this.$nextTick(() => {
        this.$refs.start.typeAheadPointer = tap;
      });
      this.$emit('setTime', time);
    },

    clearStartDate() {
     ;
    },

    onFocus() {
      console.log('OnFocus');
      //this.$emit('focus');
    },

    onBlurr() {
      this.$emit('blurr');
    },

    changeHandler(eventData) {
      console.log(eventData);
    },
    convertMinsToHrsMins(mins) {
      let h = Math.floor(mins / 60);
      let m = mins % 60;
      h = h < 10 ? '0' + h : h;
      m = m < 10 ? '0' + m : m;
      return `${h}:${m}`;
    },

    TimeStr2Minutes(time) {
      const a = time.split(':');
      const mins = a[0] * 60 + 1 * a[1];
      console.log('time in mins:', mins);
      return mins;
    },

    Minutes2TimeStr(minutesOfDay) {
      let hours = Math.floor(minutesOfDay / 60);
      let mins = minutesOfDay % 60;
      hours = hours < 10 ? '0' + hours : hours;
      mins = mins < 10 ? '0' + mins : mins;
      return `${hours}:${mins}`;
    },
  },

  mounted() {
    let index = 33;
    if (this.value && isValidTime(this.value)) {
      const mins = this.TimeStr2Minutes(this.value);
      index = mins / 15 + 1;
      this.startTime = this.value;
    }

    console.info('select index:', index);
    this.$nextTick(() => {
      this.$refs.start.typeAheadPointer = index;
    });
  },
};

import '@/styles/select-variables.scss';
</script>

<style lang="scss">
@import '@/styles/colors.scss';

.choice-info {
  display: flex;
  white-space: nowrap;
  font-size: 14px;
  overflow-y: visible;
  width: 100%;
}

.v-select {
  margin-top: 0px;
  background-color: $white;
  width: 100px;
}

@media (max-width: 767px) {
  .v-select {
    width: 80px;
  }
}

button.vs__clear {
  line-height: 18px !important;
}
</style>
